import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CourseService } from '@app/_services/course.service';
import { first } from 'rxjs/operators';

@Component({ templateUrl: 'overview.component.html', selector: 'overview' })
export class OverviewComponent {
    
    loading = false;
    sectionId:any;
    overview:any;
    theme:any = "dark'";

    constructor(private route: ActivatedRoute, private courseService: CourseService) { }

    ngOnInit() {
        this.route.paramMap.subscribe(params => {
            this.sectionId = params.get('id');
            this.getSection();
        })
    }

    getSection() {
        this.courseService.getSection(this.sectionId).pipe(first()).subscribe(data => {
            this.loading = false;
            this.overview = data.section;
            this.theme = data.theme.toLowerCase();
        });
    }

    save() {
        return this.courseService.addProgress(this.sectionId);
    }
}